import { useEffect } from "react";
import { getAudio } from "@/audio";
import { runSinkingHum } from "@/humSurprise";

export const useHum = (on) => {
  useEffect(() => {
    if (!on) return;
    const { ctx, out } = getAudio();
    const master = ctx.createGain();
    master.gain.value = 0.06;
    const fadeIn = ctx.createGain();
    fadeIn.gain.setValueAtTime(0, ctx.currentTime);
    fadeIn.gain.linearRampToValueAtTime(1, ctx.currentTime + 5);
    master.connect(fadeIn).connect(out);
    const filter = ctx.createBiquadFilter();
    filter.type = "lowpass";
    filter.frequency.value = 420;
    filter.connect(master);
    const voices = [[110, "sine", 0.5], [55.4, "sine", 0.6], [82.6, "triangle", 0.15]].map(([f, type, g]) => {
      const o = ctx.createOscillator();
      const og = ctx.createGain();
      o.type = type;
      o.frequency.value = f;
      og.gain.value = g;
      o.connect(og).connect(filter);
      o.start();
      return { o, f };
    });
    const nodes = voices.map((v) => v.o);
    const stopCycle = runSinkingHum(ctx, voices);
    const lfo = ctx.createOscillator();
    const lfoGain = ctx.createGain();
    lfo.frequency.value = 0.08;
    lfoGain.gain.value = 0.015;
    lfo.connect(lfoGain).connect(master.gain);
    lfo.start();
    nodes.push(lfo);
    return () => {
      stopCycle();
      fadeIn.gain.cancelScheduledValues(ctx.currentTime);
      fadeIn.gain.setTargetAtTime(0, ctx.currentTime, 0.3);
      setTimeout(() => {
        nodes.forEach((n) => n.stop());
        fadeIn.disconnect();
      }, 1500);
    };
  }, [on]);
};
